import { connect } from 'react-redux';
import SiteReady from './SiteReady';

const mapStateToProps = ({ siteInfo }) => ({
    siteInfo,
});

export default connect(mapStateToProps)(SiteReady);
